const entry = {
  secure: '企業空間已安全識別',
  title: '從企業真值開始，而不是重新填寫。',
  body: 'Navigator 已識別此邀請身分下的企業專案。繼續上次專案，或為新的市場目標開始診斷。',
  identity: '目前邀請身分',
  changeEmail: '切換登入信箱',
  signingOut: '正在登出…',
  signOutFailed: '暫時無法登出，請檢查網路後重試。',
  existingTitle: '回到你的專案',
  existingBody: '預設選取上次使用的專案',
  projectCount: '{count} 個專案',
  ready: '已就緒',
  continueSetup: '繼續完成專案',
  targetMarkets: '目標市場',
  lastOpened: '最近進入',
  noMarkets: '尚未設定',
  viewProjects: '查看既有專案',
  startDiagnosis: '開始新診斷',
  serverTruth: '專案清單來自伺服器；本機只記住上次選擇。',
  emptyTitle: '建立第一個專案',
  emptyHint: '此邀請身分下尚無企業專案',
  emptyLead: '四步完成企業接入',
  emptyBody: '填寫企業與產品資訊、選擇目標市場、加入公開連結及專案資料，再確認診斷範圍。',
  emptyNote: '資料確認前可儲存並離開。',
}

export default entry
